._presetAreaItem_ab1f4_1 {
  outline: none; }
